import React from "react";

interface OrganizationBasicInfoProps {
  formData: {
    organizationName: string;
    englishName: string;
    classification: string;
    address: string;
    email: string;
    phone: string;
    country: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const OrganizationBasicInfo: React.FC<OrganizationBasicInfoProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      {/* Top Section - Two Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        {/* Tên tổ chức */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tên tổ chức <span className="text-red-500">(*)</span>
          </label>
          <input
            type="text"
            value={formData.organizationName}
            onChange={(e) =>
              handleInputChange("organizationName", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Tên tổ chức..."
          />
        </div>

        {/* Tên tiếng Anh */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tên tiếng Anh <span className="text-red-500">(*)</span>
          </label>
          <input
            type="text"
            value={formData.englishName}
            onChange={(e) => handleInputChange("englishName", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Tên tiếng Anh..."
          />
        </div>
      </div>

      {/* Middle Section - Phân loại and Địa chỉ */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        {/* Phân loại */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Phân loại <span className="text-red-500">(*)</span>
          </label>
          <select
            value={formData.classification}
            onChange={(e) =>
              handleInputChange("classification", e.target.value)
            }
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Phân loại -</option>
            <option value="university">Trường Đại học</option>
            <option value="research-institute">Viện Nghiên cứu</option>
            <option value="government-agency">Cơ quan Chính phủ</option>
            <option value="ngo">Tổ chức Phi chính phủ</option>
            <option value="enterprise">Doanh nghiệp</option>
            <option value="international-organization">Tổ chức Quốc tế</option>
          </select>
        </div>

        {/* Địa chỉ - spans 2 columns */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Địa chỉ
          </label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) => handleInputChange("address", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Địa chỉ..."
          />
        </div>
      </div>

      {/* Second Row - Three Columns: Email, Điện thoại, Quốc gia */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Emaill..."
          />
        </div>

        {/* Điện thoại */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Điện thoại
          </label>
          <input
            type="tel"
            value={formData.phone}
            onChange={(e) => handleInputChange("phone", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="..."
          />
        </div>

        {/* Quốc gia */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Quốc gia <span className="text-red-500">(*)</span>
          </label>
          <select
            value={formData.country}
            onChange={(e) => handleInputChange("country", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">- Chọn quốc gia -</option>
            <option value="vietnam">Việt Nam</option>
            <option value="usa">Hoa Kỳ</option>
            <option value="japan">Nhật Bản</option>
            <option value="south-korea">Hàn Quốc</option>
            <option value="singapore">Singapore</option>
            <option value="thailand">Thái Lan</option>
            <option value="malaysia">Malaysia</option>
            <option value="philippines">Philippines</option>
            <option value="indonesia">Indonesia</option>
            <option value="china">Trung Quốc</option>
            <option value="australia">Úc</option>
            <option value="germany">Đức</option>
            <option value="france">Pháp</option>
            <option value="uk">Anh</option>
            <option value="canada">Canada</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default OrganizationBasicInfo;
